export default __webpack_public_path__ + "static/media/COMO_FUNCIONA.3e7fe83a.jpg";